import { Separator } from "..//separator";
import { SidebarTrigger } from "..//sidebar";

export function DashboardLayout({
  children,
  leftSide,
  rightSide,
}: {
  children: React.ReactNode;
  leftSide?: React.ReactNode;
  rightSide?: React.ReactNode;
}) {
  return (
    <div className="@container px-4 pb-6 md:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-6xl space-y-4">
        <header className="flex min-h-20 shrink-0 flex-wrap items-center gap-3 border-b py-4 transition-all ease-linear">
          {/* Left side */}
          <div className="flex flex-1 items-center gap-2">
            <SidebarTrigger className="-ms-1" />
            {leftSide && (
              <Separator
                orientation="vertical"
                className="me-2 data-[orientation=vertical]:h-4"
              />
            )}
            {leftSide}
          </div>
          {/* Right side */}
          {rightSide}
        </header>
        {children}
      </div>
    </div>
  );
}
